import React from 'react';
import { Icon } from 'ui';

type Props = {
  filename: string | undefined | null;
  url: string;
};
function IconThumbnail({ filename }: Props) {
  const regexIcon: [RegExp, Icon['props']['name']][] = [
    [/(.*\.pdf)/, 'document-text'],
    [/(.*\.mp3|.*\.wav)/, 'volume-up'],
    [/(.*\.mp4|.*\.avi|.*\.mov)/, 'video-camera'],
    [/(.*\.txt)/, 'document-text'],
    [/(.*\.html)/, 'document-text'],
    [/(.*\.docx)/, 'document-text'],
    [/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/, 'photograph'],
    [/(.*\.zip|.*\.rar|.*\.tar)/, 'folder-download'],
  ];

  const icons = regexIcon
    .map(([regex, icon]) => (filename.match(regex) ? icon : undefined))
    .filter((icon) => icon !== undefined);

  const icon = icons.length ? icons[0] : 'file outline';

  return (
    <div className="flex h-full items-center justify-center">
      <Icon fitted name={icon} size="huge" />
    </div>
  );
}

export default IconThumbnail;
